import { FC } from "react";
import { wrapImage } from "utils";

interface RATServiceOrderResolutionDetailsProps {
  resolution?: {
    notes?: string;
    supportingImageUrls?: string[];
  }
  result?: string;
}

export const RATServiceOrderResolutionDetails: FC<
  RATServiceOrderResolutionDetailsProps
> = ({ resolution, result }) => {
  return (
    <div className="relative">
      <img
        src={
          result === "Passed"
            ? "/passed-stamp.png"
            : "/failed-stamp.png"
        }
        className="h-24 absolute right-4 "
        alt="result"
      />
      <div className="space-y-6 divide-y divide-gray-200">
        <div className="pt-6">
          <div className="">
            <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-3">
                  <span className="block text-sm font-light text-gray-700">
                    Notes
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    {resolution?.notes || "N/A"}
                  </div>
                </div>
                <div className='col-span-3'>
                  <span className='block text-sm font-light text-gray-700'>
                    Supporting Images
                  </span>
                  {resolution?.supportingImageUrls?.length ? (
                    <div className='mt-1 grid grid-cols-3 gap-3'>
                      {resolution?.supportingImageUrls?.map((image) =>
                        wrapImage(
                          <img
                            src={image}
                            alt={"supporting details"}
                            className='w-full h-56 text-xs object-cover object-center rounded'
                          />
                        )
                      )}
                    </div>
                  ) : (
                    <div className='border-2 border-dashed border-gray-300 rounded-md mt-2 h-64 items-center justify-center flex text-gray-600'>
                      Images not provided
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RATServiceOrderResolutionDetails;
